import { useEffect, useState } from 'preact/hooks';

import { getDebugVersion, setDebugVersion, getConfig } from '@/config';
import { loadDraft } from '@/api';
import { getFormConfig } from '../api';
import Box from './Box';
import Rule from './Rule';

function contains(a = '', b = '') {
	return a?.toLowerCase().indexOf(b?.toLowerCase()) > -1;
}

export default function Deployment({ deployment, searchValue, toggleDrawer, refresh }) {
	const [surveyData, setSurveyData] = useState({});
	const [hasDraft, setHasDraft] = useState(false);
	useEffect(() => {
		loadDraft(deployment.id, {
			onSuccess: response => {
				if (response.OK && Object.keys(response.deployment ?? {}).length > 1) {
					setHasDraft(true);
				}
			},
		});
	}, [deployment]);

	useEffect(() => {
		deployment.rules?.forEach(rule => {
			const [formKey, _domain, divName] = rule.then[0]?.args ?? [];
			const domain =
				getConfig(config => config?.mopinion?.proxyCustomDomain ?? config?.mopinion?.proxyCacheDomain) ?? _domain;

			getFormConfig(
				{
					formKey,
					domain,
				},
				{
					onSuccess: data => {
						const name = data?.properties?.name;
						const formType = determineFormType(data);
						const id = data?.properties?.id;
						const domain = data?.sendOptions?.domain;
						const projectId = data?.properties?.project_id;
						const sliderPosition = formType === 'Slide-in' ? data?.properties?.trigger?.slider?.position : null;

						setSurveyData(prev => ({
							...prev,
							[data?.surveyKey]: {
								name,
								formType,
								id,
								domain,
								projectId,
								sliderPosition,
							},
						}));
					},
				}
			);
		});
	}, [deployment]);

	return (
		<Box name="list-container">
			<Box name="subheader">
				<Box name="flex">
					<Box classes={['mr-1']}>Deployment: {deployment.name}</Box>
					<Box name="chip" classes={deployment.published ? ['active'] : []}>
						{deployment.published ? 'Active' : 'Inactive'}
					</Box>
				</Box>
				{hasDraft && (
					<Box name="version-container">
						<Box name="version-label">Version</Box>
						<Box name="select-container">
							<select
								value={getDebugVersion(deployment.id)}
								onChange={e => {
									setDebugVersion(deployment.id, e.target.value);
									refresh();
								}}
							>
								<option value="live">Live</option>
								<option value="draft">Draft</option>
							</select>
						</Box>
					</Box>
				)}
			</Box>
			{deployment.rules
				?.filter(rule => {
					const [formKey] = rule.then[0]?.args ?? [];
					return (
						!searchValue ||
						contains(surveyData[formKey]?.name, searchValue) ||
						contains(surveyData[formKey]?.formType, searchValue)
					);
				})
				.map(rule => {
					const [formKey] = rule.then[0]?.args ?? [];
					return <Rule rule={rule} survey={surveyData[formKey]} surveyData={surveyData} toggleDrawer={toggleDrawer} />;
				})}
		</Box>
	);
}

function determineFormType(data = {}) {
	if (data.properties?.modal === false) {
		return 'Embedded';
	}

	if (data.properties?.trigger?.slider?.type) {
		return 'Slide-in';
	}

	return 'Modal';
}
